<template lang="pug">
yz-card.mt-4(outlined)
  .pa-6
    div.d-flex.align-center
      .yz-heading-8.text-neutral-700 Service details
      v-spacer
      yz-btn(v-if="serviceId" label="View service history" size="sm" @click="$router.push({ name: 'HQServiceHistory', params: { id: serviceId, origin: 'HQEditService' } })")
    v-row.mt-3(no-gutters)
      v-col.pr-3(cols="6")
        .yz-heading-9.text-neutral-500 Name
        yz-text-field.mt-2(:value="product.name" placeholder="Name" size="lg" required @input="onUpdateProduct('name', $event)")
      v-col.pl-3(cols="6")
        .yz-heading-9.text-neutral-500 Type
        yz-dropdown.mt-2(:value="type" placeholder="Type" :items="serviceTypes" item-text="text" item-value="value" size="lg" required @input="$emit('update:type', $event)")
      v-col.pr-3.mt-4(cols="6")
        .yz-heading-9.text-neutral-500 Description (Optional)
        yz-text-field.mt-2(:value="product.description" placeholder="Description" size="lg" @input="onUpdateProduct('description', $event)")
      v-col.pl-3.mt-4(cols="6")
        .yz-heading-9.text-neutral-500 Cost
        yz-text-field.mt-2(:value="cost" placeholder="100" size="lg" type="number" :prefix="currencySymbol" required :rules="costRules" @input="$emit('update:cost', $event)")
      v-col.pr-3.mt-4(cols="6")
        .yz-heading-9.text-neutral-500 Group
        medication-group-dropdown.mt-2(:value="groups" attach :error="false" :team-hq-id="hqCompanyId" size="lg" @input="$emit('update:groups', $event)")
</template>

<script>
import MedicationGroupDropdown from '@/components/clinic/inventory/MedicationGroupDropdown.vue'

export default {
  components: { MedicationGroupDropdown },
  props: {
    product: { type: Object, required: true },
    type: { type: String, default: null },
    cost: { type: [String, Number], default: null },
    groups: { type: Array, default: () => [] },
    hqCompanyId: { type: [String, Number], default: null },
    serviceId: { type: [String, Number], default: null },
    costRules: { type: Array, default: () => [] },
    currencySymbol: { type: String, default: '' },
  },
  data () {
    return {
      serviceTypes: [
        { text: 'Service', value: 'service' },
        { text: 'Procedure', value: 'procedure' },
        { text: 'Investigation', value: 'investigation' },
        { text: 'Consultation', value: 'consultation' }
      ],
    }
  },
  methods: {
    onUpdateProduct (key, value) {
      this.$emit('update:product', { ...this.product, [key]: value })
    },
  },
}
</script>
